import React from 'react';
import styled from 'styled-components';

const TopBox = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
`;
const Box1 = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
`;
const Box2 = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    align-items: center;
    margin-top: 24px;
`;
const HeadTitleBox = styled.div`
    display: flex;
    width: 40%;
    min-width: 160px;
    justify-content: center;
    align-items: center;
`;
const HeadTitleText = styled.h1`
    display: inline-block;
    font-size: 30px;
    font-weight: 600;
    word-break: keep-all;
`;
const HeadLine1 = styled.div`
    border: 1px solid #388fc0;
    background-color: #388fc0;
    height: 1px;
    width: 100%;
`;

const HeadText = styled.p`
    margin-top: 12px;
    font-size: 16px;
    color: #888;
    font-weight: 400;
`;

const HeadLine2 = styled.div`
    border: 1px solid #388fc0;
    background-color: #388fc0;
    height: 1px;
    width: 10%;
`;
const HeadLine3 = styled.div`
    margin-top: 52px;
    border: 1px solid #388fc0;
    background-color: #388fc0;
    height: 1px;
    width: 100%;
`;

type TitleHeaderProps = {
    title: string;
    subTitle: string;
};

function TitleHeader(props: TitleHeaderProps) {
    const { title, subTitle } = props;
    return (
        <TopBox>
            <Box1>
                <HeadLine1></HeadLine1>
                <HeadTitleBox>
                    <HeadTitleText>{title}</HeadTitleText>
                </HeadTitleBox>
                <HeadLine1></HeadLine1>
            </Box1>
            <Box2>
                <HeadLine2></HeadLine2>
                <HeadText>{subTitle}</HeadText>
                <HeadLine3></HeadLine3>
            </Box2>
        </TopBox>
    );
}

export default TitleHeader;
